import { createSelector } from 'reselect';
import { getSelectorRoot } from 'utils/selectors';
import { ICasinoCachedGames } from 'interfaces/casino-data';

const getCasinoStore = getSelectorRoot('newCasinoStore');

const getCasinoCategories = getCasinoStore('categories');
export const getCasinoOriginalCategories = createSelector(
  [getCasinoCategories],
  categories => categories.original
);
export const getEnhancedParams = getCasinoStore('enhancedParams');

export const getGamesConfigs = getCasinoStore('gamesConfigs');
export const getCasinoCustomCategories = createSelector(
  [getCasinoCategories],
  categories => categories.custom
);
export const getCasinoOriginalCategoriesSet = createSelector(
  [getCasinoCategories],
  categories => categories.originalSet
);
export const getCasinoOriginalCategoriesSetLeftSideBar = createSelector(
  [getCasinoCategories],
  categories => categories.originalSetLeftSideBar
);
export const getCanRequestCategoriesNestedData = getCasinoStore(
  'canRequestCategoriesNestedData'
);
export const getCanRequestProvidersNestedData = getCasinoStore(
  'canRequestProvidersNestedData'
);
export const getLastPlayedCatSettings = getCasinoStore('lastPlayedCatSettings');
export const getCategoryCustomIds = getCasinoStore('categoryCustomIds');
export const getCachedGames = getCasinoStore('cachedGames');
export const getActiveGames = createSelector(
  [getCachedGames],
  (cachedGames: ICasinoCachedGames = {}) => {
    return Object.values(cachedGames)
      .filter(gameData => gameData.active)
      .reduce((acc, gameData) => {
        if (!gameData.data) {
          return acc;
        }

        acc[gameData.data.extearnal_game_id] = gameData;

        return acc;
      }, {} as ICasinoCachedGames);
  }
);
export const getMobileActiveCardID = getCasinoStore('mobileActiveCardID');
